import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import "./App.css";
import DashboardLayout from "./components/dashboard/dashboardLayout";
import ForgotPasswordPage from "./components/login/forgotPassword";
import LoginPage from "./components/login/login";
import "./style/style.scss";
import { Suspense, useEffect } from "react";
import DashboardLandingPage from "./components/dashboard/dashboardLanding";
import { useDispatch, useSelector } from "react-redux";
import UserManagement from "./components/userManagement";
import ViewPayment from "./components/paymentManagement/viewPayment";
import AddEditPayment from "./components/paymentManagement/addZimidarPayment";
import ViewSale from "./components/saleManagement/viewSale";
import EditSale from "./components/saleManagement/editSale";
import UpdateBalance from "./components/balanceManagement/updateBalance";
import BalanceSheet from "./components/balanceManagement/balanceSheet";
import Reports from "./components/reportsManagement";
import Profile from "./components/adminProfile/profile";
import { Toaster } from "react-hot-toast";
import { setCredentials } from "./authSlice";

function ProtectedRoute({ children }) {
  const { token } = useSelector((state) => state.auth);
  return token ? children : <Navigate to="/login" />;
}

function App() {
  const { token } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const checkToken = () => {
      if (!token || token === "null") {
        dispatch(setCredentials({ token: null, username: null }));
        navigate("/login");
      }
    };
    checkToken();
    const interval = setInterval(checkToken, 300000); 
    return () => clearInterval(interval);
  }, [dispatch, navigate, token]);

  return (
    <div className="App">
      <Toaster position="top-right" reverseOrder={true} />
      <Routes>
        {/* Public Routes */}
        <Route
          path="/login"
          element={
            token ? (
              <Navigate to="/dashboard" />
            ) : (
              <Suspense fallback={<div>Loading...</div>}>
                <LoginPage />
              </Suspense>
            )
          }
        />
        <Route
          path="/forgot-password"
          element={
            token ? (
              <Navigate to="/dashboard" />
            ) : (
              <Suspense fallback={<div>Loading...</div>}>
                <ForgotPasswordPage />
              </Suspense>
            )
          }
        />

        {/* Protected Routes */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route
            index
            element={
              <ProtectedRoute>
                <Suspense fallback={<div>Loading Dashboard...</div>}>
                  <DashboardLandingPage />
                </Suspense>
              </ProtectedRoute>
            }
          />
          <Route
            path="user-management"
            element={
              <ProtectedRoute>
                <Suspense fallback={<div>Loading ...</div>}>
                  <UserManagement />
                </Suspense>
              </ProtectedRoute>
            }
          />
          <Route
            path="user-management/:id"
            element={
              <ProtectedRoute>
                <Suspense fallback={<div>Loading ...</div>}>
                  <UserManagement />
                </Suspense>
              </ProtectedRoute>
            }
          />
          <Route
            path="sales-management"
            element={
              <ProtectedRoute>
                <Suspense fallback={<div>Loading ...</div>}>
                  <AddEditPayment />
                </Suspense>
              </ProtectedRoute>
            }
          />

          <Route
            path="sales-management/:id"
            element={
              <ProtectedRoute>
                <Suspense fallback={<div>Loading ...</div>}>
                  <AddEditPayment />
                </Suspense>
              </ProtectedRoute>
            }
          />
          <Route
            path="payment-management"
            element={
              <ProtectedRoute>
                <Suspense fallback={<div>Loading ...</div>}>
                  <ViewPayment />
                </Suspense>
              </ProtectedRoute>
            }
          />

          <Route
            path="sales"
            element={
              <ProtectedRoute>
                <Suspense fallback={<div>Loading ...</div>}>
                  <ViewSale />
                </Suspense>
              </ProtectedRoute>
            }
          />
          <Route
            path="edit-sale/:id"
            element={
              <ProtectedRoute>
                <Suspense fallback={<div>Loading ...</div>}>
                  <EditSale />
                </Suspense>
              </ProtectedRoute>
            }
          />
          <Route
            path="update-balances"
            element={
              <ProtectedRoute>
                <Suspense fallback={<div>Loading ...</div>}>
                  <UpdateBalance />
                </Suspense>
              </ProtectedRoute>
            }
          />
          <Route
            path="balance-sheet"
            element={
              <ProtectedRoute>
                <Suspense fallback={<div>Loading ...</div>}>
                  <BalanceSheet />
                </Suspense>
              </ProtectedRoute>
            }
          />
          <Route
            path="reports"
            element={
              <ProtectedRoute>
                <Suspense fallback={<div>Loading ...</div>}>
                  <Reports />
                </Suspense>
              </ProtectedRoute>
            }
          />

          <Route
            path="admin"
            element={
              <ProtectedRoute>
                <Suspense fallback={<div>Loading ...</div>}>
                  <Profile />
                </Suspense>
              </ProtectedRoute>
            }
          />
        </Route>
        
        {/* Redirect Home Route */}
        <Route
          path="/"
          element={<Navigate to={token ? "/dashboard" : "/login"} />}
        />
        {/* Catch-all Route for 404 Not Found */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </div>
  );
}

export default App;
